<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    };
  },
};
</script>

<style>
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: "Roboto";
    font-size: 16px;
  }

  #app {
    width: 100%;
  }

</style>
